module.exports = __webpack_public_path__ + "8e0636065fa9d21de8434ec88566b0fc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/tiger-suit-s.png
// module id = 1407
// module chunks = 0